import { render, staticRenderFns } from "./ImportActive.vue?vue&type=template&id=23b35961&scoped=true"
import script from "./ImportActive.vue?vue&type=script&lang=js"
export * from "./ImportActive.vue?vue&type=script&lang=js"
import style0 from "./ImportActive.vue?vue&type=style&index=0&id=23b35961&prod&scoped=true&lang=css"
import style1 from "./ImportActive.vue?vue&type=style&index=1&id=23b35961&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b35961",
  null
  
)

export default component.exports